import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('geometric-flowers', false, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [_createVNode("path", {
    "d": "M28.3117 27.8317C31.6858 24.4575 29.5584 16.8596 23.5599 10.8611C17.5615 4.86265 9.96351 2.73522 6.58938 6.10935C3.21525 9.48348 5.34269 17.0815 11.3411 23.0799C17.3396 29.0784 24.9376 31.2058 28.3117 27.8317Z",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M28.3117 19.2621C31.6858 22.6362 29.5584 30.2342 23.56 36.2326C17.5615 42.2311 9.96352 44.3585 6.58938 40.9844C3.21525 37.6103 5.34269 30.0123 11.3411 24.0138C17.3396 18.0154 24.9376 15.8879 28.3117 19.2621Z",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M19.6883 27.8317C16.3142 24.4575 18.4416 16.8596 24.44 10.8611C30.4385 4.86265 38.0365 2.73522 41.4106 6.10935C44.7847 9.48348 42.6573 17.0815 36.6589 23.0799C30.6604 29.0784 23.0624 31.2058 19.6883 27.8317Z",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M19.6883 19.2621C16.3142 22.6362 18.4416 30.2342 24.4401 36.2326C30.4385 42.2311 38.0365 44.3585 41.4106 40.9844C44.7847 37.6103 42.6573 30.0123 36.6589 24.0138C30.6604 18.0154 23.0624 15.888 19.6883 19.2621Z",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});